import React, {Component, PropTypes} from 'react';
import Button from './Button';
import classNames from 'classnames';
import OverlayTrigger from './OverlayTrigger';

class Modal extends Component {

    static propTypes = {
        /**
         * Text to shown in the header of the modal
         */
        header: PropTypes.string,
        /**
         * The button to trigger the display of the modal
         */
        trigger: PropTypes.node.isRequired,
        /**
         * FixedFooter styled modal
         * @default false
         */
        fixedFooter: PropTypes.bool,
        /**
         * BottomSheet styled modal
         * @default false
         */
        bottomSheet: PropTypes.bool,

        children: PropTypes.node,
        onClickAgree: PropTypes.func,
        onClickDisagree: PropTypes.func,
        textAgree: PropTypes.string,
        textDisagree: PropTypes.string,
        agreeElement: PropTypes.node,
        className: PropTypes.string,
        closeOnAgree: PropTypes.bool
    };

    static defaultProps = {
        fixedFooter: false,
        bottomSheet: false,
        textAgree: 'Agree',
        textDisagree: 'Disagree',
        closeOnAgree: true,
        onClickDisagree: () => {
        }
    };


    render() {
        let {
            header, trigger, children, fixedFooter, bottomSheet, onClickAgree, onClickDisagree, textAgree, closeOnAgree,
            textDisagree, agreeElement, className, ...props
        } = this.props;

        let classes = {modal: true};
        classes['modal-fixed-footer'] = fixedFooter;
        classes['bottom-sheet'] = bottomSheet;

        return (
            <OverlayTrigger overlay={
                  <div className={classNames(classes, className)} {...props}>
                    <div className="modal-content">
                      <h4>{header}</h4>
                      {children}
                    </div>
                    <div className="modal-footer">
                      <Button waves="light" modal="close" onClick={onClickDisagree} flat>{textDisagree}</Button>

                      {agreeElement ?
                        <div>{agreeElement}</div>
                        :
                        onClickAgree && closeOnAgree ?
                         <Button onClick={onClickAgree} waves="light" modal="close" flat>{textAgree}</Button>
                            :
                         <Button onClick={onClickAgree} waves="light" flat>{textAgree}</Button>
                      }
                    </div>
                  </div>
                }>
                <span ref="trigger">
                    {trigger}
                </span>
            </OverlayTrigger>
        );
    }
}

export default Modal;